/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { removeAlert, selectAlertsData } from '../../redux/features/alerts/alerts.slice';

export function SnackbarHandler({ children }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const data = useSelector(selectAlertsData);

  useEffect(() => {
    data.forEach((alert) => {
      // remove alert from the redux store
      dispatch(removeAlert(alert.id));
      // show the snackbar
      enqueueSnackbar(alert.message, {
        key: alert.id,
        variant: alert.type,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    });
  });

  return children;
}
